import { adminHttpClient } from '../commons/adminHttpClient'
import SaveCompanyUserRequest from './common/saveCompanyUserRequest'

export const updateEmployee = (request: SaveCompanyUserRequest): Promise<any> => {
  return adminHttpClient.put(`/Companies/UpdateEmployee`, request)
}

export default updateEmployee
